module.exports = __webpack_public_path__ + "img/L1.e6b563e5.png";